
import genericService from '../genericService';

const urls = {
    CONFIGURATION: 'system/configuration'
}

export default {
   
    async get(body, callback){
        await genericService.get(urls.CONFIGURATION, body).then(callback);
    },
    async insert(body, callback){
        await genericService.post(urls.CONFIGURATION, body).then(callback);
    },
    async update(body, callback){
        await genericService.put(urls.CONFIGURATION, body, '_id').then(callback);
    },
}